import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { stepperConfig, tokens } from '../../constants';
import { BLACK_300, TRANSPARENT } from '../../constants/colors';
export var getStepContainerStyles = (bgColor, borderColor, isProgressState, isStateInprogressOrDisabled, isDisabled, level, props, isLargeScreen) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var config = props.config,
    size = props.size,
    _props$showMultiLevel = props.showMultiLevelStepper,
    showMultiLevelStepper = _props$showMultiLevel === void 0 ? false : _props$showMultiLevel;
  var height = showMultiLevelStepper ? isLargeScreen ? (_b = (_a = config === null || config === void 0 ? void 0 : config.multiLevelStepperSize) === null || _a === void 0 ? void 0 : _a.desktop) === null || _b === void 0 ? void 0 : _b[level] : (_d = (_c = config === null || config === void 0 ? void 0 : config.multiLevelStepperSize) === null || _c === void 0 ? void 0 : _c.mobile) === null || _d === void 0 ? void 0 : _d[level] : (_e = config === null || config === void 0 ? void 0 : config[size]) === null || _e === void 0 ? void 0 : _e.stepperSize;
  var width = showMultiLevelStepper ? isLargeScreen ? (_g = (_f = config === null || config === void 0 ? void 0 : config.multiLevelStepperSize) === null || _f === void 0 ? void 0 : _f.desktop) === null || _g === void 0 ? void 0 : _g[level] : (_j = (_h = config === null || config === void 0 ? void 0 : config.multiLevelStepperSize) === null || _h === void 0 ? void 0 : _h.mobile) === null || _j === void 0 ? void 0 : _j[level] : (_k = config === null || config === void 0 ? void 0 : config[size]) === null || _k === void 0 ? void 0 : _k.stepperSize;
  var borderWidth;
  if (showMultiLevelStepper) {
    borderWidth = isProgressState ? 1 : 0;
  } else {
    borderWidth = isStateInprogressOrDisabled ? 2 : 0;
  }
  return {
    backgroundColor: isDisabled && showMultiLevelStepper ? BLACK_300 : bgColor,
    borderColor,
    borderWidth,
    height,
    width
  };
};
export var getStepperConnectorStyles = level => ({
  flexGrow: level === 'L3' ? 1 : 0
});
export var getTypography = (level, type, isBold, isLargeScreen) => {
  var _a, _b;
  var LEVEL = {
    small: {
      L1: {
        heading: 'body-single-line-md-bold',
        subHeading: 'body-para-sm'
      },
      L2: {
        heading: isBold ? 'body-single-line-sm-bold' : 'body-single-line-sm',
        subHeading: 'body-para-xs'
      },
      L3: {
        heading: isBold ? 'body-single-line-sm-bold' : 'body-single-line-sm',
        subHeading: 'body-para-xs'
      }
    },
    large: {
      L1: {
        heading: 'body-single-line-lg-bold',
        subHeading: 'body-para-md'
      },
      L2: {
        heading: isBold ? 'body-single-line-md-bold' : 'body-single-line-md',
        subHeading: 'body-para-sm'
      },
      L3: {
        heading: isBold ? 'body-single-line-sm-bold' : 'body-single-line-sm',
        subHeading: 'body-para-xs'
      }
    }
  };
  return (_b = (_a = LEVEL === null || LEVEL === void 0 ? void 0 : LEVEL[isLargeScreen ? 'large' : 'small']) === null || _a === void 0 ? void 0 : _a[level]) === null || _b === void 0 ? void 0 : _b[type];
};
export var getContentContainerStyle = (level, isLargeScreen, direction) => {
  var vertical = direction === 'vertical';
  var isLevelL3 = level === 'L3';
  var marginBottom = isLargeScreen ? isLevelL3 ? tokens.spacing.SPACING_16 : tokens.spacing.SPACING_20 : isLevelL3 ? tokens.spacing.SPACING_12 : tokens.spacing.SPACING_16;
  return Object.assign({}, vertical ? {
    marginLeft: tokens.spacing.SPACING_8,
    flex: 1,
    marginBottom: marginBottom
  } : {
    alignItems: 'center',
    marginTop: tokens.spacing.SPACING_8
  });
};
export var getStepperStyles = (props, isLargeScreen) => {
  var direction = props.direction,
    stepperConnectorColor = props.stepperConnectorColor;
  var vertical = direction == 'vertical';
  var stepperLineStylesForVertical = {
    width: 1
  };
  var stepperLineStylesForHorizontal = {
    height: 2
  };
  return StyleSheet.create({
    stepperOuterContainer: {
      display: 'flex',
      flexDirection: vertical ? 'column' : 'row'
    },
    stepperContainer: Object.assign({}, vertical ? {
      flexDirection: 'row'
    } : {
      minWidth: 84,
      flexDirection: 'column',
      flex: 1
    }),
    stepContainer: {
      flexDirection: vertical ? 'column' : 'row',
      alignItems: 'center'
    },
    step: {
      borderRadius: tokens.borderRadius.BORDER_RADIUS_100,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    stepperConnecter: Object.assign({
      borderWidth: 1,
      borderColor: stepperConnectorColor,
      borderStyle: 'dashed',
      flexGrow: 1
    }, vertical ? stepperLineStylesForVertical : stepperLineStylesForHorizontal),
    multiLevelStepperConnector: Object.assign({
      flexGrow: 1
    }, vertical ? stepperLineStylesForVertical : stepperLineStylesForHorizontal),
    showLeftStepperConnecter: Object.assign({}, vertical ? {
      display: 'none'
    } : {
      backgroundColor: TRANSPARENT,
      borderWidth: 0
    }),
    showRightStepperConnecter: {
      backgroundColor: TRANSPARENT,
      borderWidth: 0
    },
    heading: Object.assign({}, !vertical && {
      textAlign: 'center'
    }),
    subHeading: Object.assign({
      marginTop: tokens.spacing.SPACING_4
    }, !vertical && {
      textAlign: 'center'
    }),
    childrenContainer: {
      marginTop: tokens.spacing.SPACING_12
    },
    level3Step: {
      marginLeft: isLargeScreen ? tokens.spacing.SPACING_28 : tokens.spacing.SPACING_22
    },
    connectorContainer: {
      position: 'relative',
      width: 1,
      overflow: 'hidden'
    },
    animatedConnector: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      transformOrigin: 'top'
    }
  });
};
export var getStepperProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(stepperConfig === null || stepperConfig === void 0 ? void 0 : stepperConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.stepper) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};